









import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "OfficeOverview",
    components: { PageHeader, Page },
})
export default class OfficeOverview extends Vue {
    get office() {
        return this.$context.office;
    }
}
